function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.816 15.453c.159.132.312.24.443.37 1.83 1.806 3.656 3.615 5.483 5.423.066.065.176.125.188.2.022.14.043.342-.036.424-.078.082-.285.075-.426.052-.085-.014-.156-.13-.23-.203a9331.857 9331.857 0 01-5.605-5.548c-.09-.09-.168-.193-.26-.301-1.948 1.596-4.124 2.324-6.606 1.937-2.088-.326-3.782-1.356-5.074-3.008-2.549-3.26-2.178-7.906.831-10.608 3.25-2.918 7.834-2.924 10.983 0 3.041 2.824 3.606 7.727.31 11.262zm1.536-5.474c0-3.99-3.293-7.285-7.28-7.282-4.08.002-7.382 3.245-7.386 7.253-.004 4.001 3.298 7.278 7.326 7.271 3.995-.007 7.34-3.307 7.34-7.242z",
  fill: "gray",
  stroke: "gray",
  strokeWidth: 3,
  fillRule: "evenodd"
});

function SvgFeatureSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgFeatureSearch;